import type { ActionArray } from '$components/actions';
import type { IconComponentType } from '$mds/IconWrapper';
import type { ButtonSize, ButtonVariant, ButtonWidth } from '../Buttons';

export enum DialogStatus {
  Open = 'open',
  Closing = 'closing',
  Closed = 'closed'
}

export interface DialogButtonAction {
  label: string;
  variant?: ButtonVariant;
  size?: ButtonSize;
  href?: string;
  disabled?: boolean;
  loading?: boolean;
  width?: ButtonWidth;
  icon?: IconComponentType;
  action?: () => void;
  use?: ActionArray;
}
